import React, { useEffect } from "react";
import { FormLabel } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fileSelection, setCompalsaryMediaUpload, setDeleteProfessionalServiceAllFiles, setDeleteProfessionalServiceAllFilesForUiShow } from "../../redux/reducers/createOrderSlice";
import { toast } from "react-toastify";
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const FileInput = ({ handleProServiceArrayForImage, subOptionData, filetext }) => {
  const { professionalServiceAllFiles, professionalServiceAllFilesForUiShow, compalsaryMediaUpload } = useSelector((state) => state.createOrderSlice)

  const dispatch = useDispatch()
  const handleUploadChange = (event) => {
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    const validVideoTypes = ["video/mp4"];
    if (!event.target.files || event.target.files.length === 0) {
      toast.error("Please select a file");
      return;
    }
    const selectedFileName = event.target.files[0]?.name;

    // Check if the file is already in the list of uploaded files
    if (professionalServiceAllFilesForUiShow.some(file => file?.file?.name === selectedFileName)) {
      toast.error("This file has already been uploaded");
      return;
    }
    if ((professionalServiceAllFilesForUiShow?.filter(item => subOptionData?._id === item?.serviceId))?.length > 5) {
      toast.error("You can select maximum of 6 files")
    }
    else if (!validImageTypes.includes(event.target.files[0]?.type) &&
      !validVideoTypes.includes(event.target.files[0]?.type)) {
      toast.error("Please select the correct format file")
    }
    else if (event.target.files[0].size > 100 * 1024 * 1024) {
      toast.error("Please upload less than 100 mb")
    }
    else {
      const file = event.target.files[0];
      if (file) {



        let dataFiles = {
          fileName: `professional_order_data/${file?.name}`,
          ContentType: file?.type
        }
        dispatch(fileSelection({ dataFiles: dataFiles, dispatch: dispatch, fileLink: { fileData: file, serviceId: subOptionData?._id }, serviceId: subOptionData?._id }))

      }
    }
    document.getElementById('uploadFile').value = null;


  }
  const deleteFileHandler = (idx) => {
    const updatedArrayForSendPreSignedUrl = professionalServiceAllFiles.filter((file, index) => index !== idx);

    dispatch(setDeleteProfessionalServiceAllFiles(updatedArrayForSendPreSignedUrl))

    const updatedArrayForUiShow = professionalServiceAllFilesForUiShow.filter((file, index) => index !== idx);

    dispatch(setDeleteProfessionalServiceAllFilesForUiShow(updatedArrayForUiShow))

  }

  useEffect(() => {
    if (subOptionData?.isMedia === 'yes') {
      dispatch(setCompalsaryMediaUpload(compalsaryMediaUpload ? [...compalsaryMediaUpload, subOptionData?._id] : [subOptionData?._id]))
    }
  }, [subOptionData])
  return (
    <>
      <div className="upload-file-main" id={subOptionData?._id}>

        <FormLabel required={subOptionData?.isMedia === 'yes'}>{filetext}</FormLabel>
        <div className="file-input-wrap d-flex">

          {/* {professionalServiceAllFilesForUiShow &&
            professionalServiceAllFilesForUiShow?.length > 0 &&
            professionalServiceAllFilesForUiShow?.map((file, idx) => {
              const [contentType, base64Data] = file.split(';base64,');
              return (
                <div key={idx} className="file-img">
                  {contentType.includes("image") ? (
                    <img src={file} alt={`Image ${idx}`} />
                  ) : contentType.includes("video") ? (
                    <video width="90" height="90" controls>
                      <source src={`data:${contentType};base64,${base64Data}`} type={contentType} />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    null
                  )}
                </div>
              );
            })} */}

          {professionalServiceAllFilesForUiShow &&
            professionalServiceAllFilesForUiShow?.length > 0 &&
            professionalServiceAllFilesForUiShow?.map((file, idx) => {

              return (
                <div>
                  {

                    (subOptionData?._id === file?.serviceId) ?
                      <div key={idx} className="img-f-b">
                        {
                          file?.type?.includes("image") ? (
                            <>


                              <div className={'mediaDeleteIcon'}>
                                <img src={`${file?.file}`} alt={`Image ${idx}`} />
                                <div className="del-img" onClick={() => deleteFileHandler(idx)}><FontAwesomeIcon icon={faTrash} /></div>
                              </div>

                            </>
                          ) : file?.file?.type?.includes("video") ? (
                            // <video width="90" height="90" controls>
                            //   <source src={URL.createObjectURL(file)} type={file.type} />
                            //   Your browser does not support the video tag.
                            // </video>
                            <div className={'mediaDeleteIcon'}>
                              <img src="/assets/images/thumbNailVideo.jpeg" alt={`Image ${idx}`} />
                              {/* <button onClick={() => deleteFileHandler(idx)}>faTrash</button> */}
                              <div onClick={() => deleteFileHandler(idx)}><FontAwesomeIcon icon={faTrash} /></div>

                            </div>

                          ) : (
                            <div className={'mediaDeleteIcon'}>
                              <img src="/assets/images/thumbNailVideo.jpeg" alt={`Image ${idx}`} />
                              {/* <button onClick={() => deleteFileHandler(idx)}>faTrash</button> */}
                              <div onClick={() => deleteFileHandler(idx)}><FontAwesomeIcon icon={faTrash} /></div>

                            </div>
                          )
                        }
                      </div>
                      : null
                  }
                </div>

              );
            })}

          {((professionalServiceAllFilesForUiShow?.filter(item => subOptionData?._id === item?.serviceId))?.length < 5) ?
            <div className="file-input">
              <div className="position-relative up-lab">
                <label>Add</label>
                <input type="file" id="uploadFile" className="custom-file-input" onChange={handleUploadChange} />
              </div>
            </div> : null}
        </div>
      </div>
    </>
  );
};

export default FileInput;
